import LdGatedContent from 'lion-vue-src/Shared/components/LdFeatureGate/LdGatedContent';
export default LdGatedContent;